<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input-facade
      v-model="inputValue"
      masked
      class="form-control text-uppercase"
      :id="inputId"
      :mask="inputMask"
      :disabled="disabled"
      :placeholder="inputPlaceholder"
      @change="emitValue('change', $event)"
      @input="emitValue('input', $event)"
      @blur="emitValue('blur', $event)"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import { PersonalIdentifications } from '@/common/enums/PersonalIdentifications'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'IdentificationCodeInput',

  components: { Hint },

  mixins: [applicationInputMixin, applicationFormMixin, visitorsSectionMixin, visitorInputMixin],

  props: {
    inputLabel: {
      default: 'Код подразделения'
    },

    inputName: {
      default: 'identification_code'
    },

    inputHint: {
      default: undefined
    },

    inputPlaceholder: {
      default: '___-___'
    }
  },

  computed: {
    inputId() {
      let inputId = `form-visitor-identification-code-${this.visitorIndex}`
      if (this.transportIndex !== null) {
        return `form-visitor-transport-${this.transportIndex}-driver-${this.visitorIndex}-identification-code`
      }

      return inputId
    },

    inputMask() {
      let mask = 'AAAAAAAAAAA'
      if (this.visitor.personal.identification_id === PersonalIdentifications.PASSPORT) {
        mask = '###-###'
      }

      return mask
    }
  }
}
</script>
